import HotdogIcon from "./HotdogIcon";

const ITEMS = [
    "Frankfurter i svøb",
    "Ristet pølse",
    "Bøfsandwich",
    "Flæskestegssandwich",
    "Cocio & fadøl",
    "Gl. daws is",
    "Når der er fest, bli'r det bedst",
    "100% uforpligtende",
];

function Row({ ariaHidden }) {
    return (
        <div className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
            {ITEMS.map((t, i) => (
                <span key={i} className="flex items-center gap-6 pr-6 sm:gap-10 sm:pr-10">
                    <span className="whitespace-nowrap font-serif text-2xl italic text-paper sm:text-3xl">{t}</span>
                    <HotdogIcon className="h-5 w-8 shrink-0 text-gold" />
                </span>
            ))}
        </div>
    );
}

export default function Marquee({ rotate = "-rotate-1", reverse = false }) {
    return (
        <div data-testid="marquee" className={`relative -mx-2 overflow-hidden border-y-4 border-paper bg-poelse py-4 ${rotate}`}>
            <div className={`marquee-track flex w-max${reverse ? " marquee-track-reverse" : ""}`}>
                <Row ariaHidden={false} />
                <Row ariaHidden />
            </div>
        </div>
    );
}
